<template>
  <section class="">
    <Gifts :eventId="$route.params.eventId" />
  </section>
</template>

<script>
import Gifts from "./Event.vue";

export default {
  name: "EventView",
  props: ["eventId, event"],
  components: {
    Gifts,
  },
};
</script>
